import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function loadingSpinner() {
  return <Spinner animation="border" variant="primary" />;
}
